import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DxNumberBox = _resolveComponent("DxNumberBox");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createVNode(_component_DxNumberBox, {
                id: identification,
                name: identification,
                disabled: disabled,
                "read-only": _ctx.readOnly,
                placeholder: _ctx.placeholder,
                validationStatus: _ctx.validationState,
                "show-clear-button": _ctx.showClearButton,
                "show-spin-buttons": _ctx.showSpinButton,
                "use-large-spin-buttons": _ctx.largeSpin,
                "input-attr": _ctx.inputAttrInternal,
                format: _ctx.numberFormat,
                min: _ctx.minValue,
                max: _ctx.maxValue,
                step: _ctx.step ?? 1,
                alignment: "center",
                ref: "txtInput",
                modelValue: _ctx.internalValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event)),
                onEnterKey: _ctx.onEnterKey,
                onFocusOut: _ctx.onFocusOut,
                onValueChanged: _ctx.numberBoxValueChanged
            }, null, 8, ["id", "name", "disabled", "read-only", "placeholder", "validationStatus", "show-clear-button", "show-spin-buttons", "use-large-spin-buttons", "input-attr", "format", "min", "max", "step", "modelValue", "onEnterKey", "onFocusOut", "onValueChanged"])
        ]),
        _: 1
    }, 16, ["name", "error-message", "label"]));
}
